import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from './i18n'
import VueCookies from 'vue-cookies'
import VueGtag from "vue-gtag";
import { load } from 'recaptcha-v3'

Vue.config.productionTip = false

let gaTag = "";
let location = window.location.origin;
if (location.includes("swisschalet")) {
      gaTag = 'UA-162598565-1';
}
else if (location.includes("montanas")) {
      gaTag = 'UA-162598565-4';
}
else if (location.includes("kelseys")) {
      gaTag = 'UA-162598565-5';
}
else if (location.includes("st-hubert")) {
      gaTag = 'UA-162598565-2';
}
else if (location.includes("harveys")) {
      gaTag = 'UA-162598565-3';
}
else if (location.includes("eastsidemarios")) {
      gaTag = 'UA-162598565-6';
}

if (gaTag != "") {
      Vue.use(VueGtag, {
            config: { id: gaTag }
      });
}

Vue.use(VueCookies)

// Vue.prototype.$API = "http://localhost:3000";
// Vue.prototype.$TOKEN = 'd41d8cd98f00b204e9800998ecf8427e';

if (process.env.NODE_ENV == "production") {
      Vue.prototype.$API = "https://csapi.recp.ca";
      Vue.prototype.$TOKEN = 'ymKdVpqp951xsRjTOyLKFawm2aSS8Z8N8maeKdsf';
}
else {
      Vue.prototype.$API = "https://uatcsapi.recp.ca";
      Vue.prototype.$TOKEN = '8lrl0wrdY77L96DRkSWYQ1m33hgIHbDEBK78b0Ef';
}



Vue.prototype.$recaptchaSiteKey = "6LcEKekUAAAAAEUB52-IJJ9-CdgDCt94B5xqo2oz";

load(Vue.prototype.$recaptchaSiteKey).then((recaptcha) => {
      recaptcha.execute('login').then((token) => {
            Vue.prototype.$recaptchaToken = token;
      })
})

let path = window.location.search;
var matches = path.match(/storeNumber=([^&]*)/);
let storeNumber = matches[1];

let url = Vue.prototype.$API + "/v1/brand/" + storeNumber;
fetch(url, {
      method: 'GET',
      headers: new Headers({
            'x-api-key': Vue.prototype.$TOKEN
      })
})
      .then(stream => stream.json())
      .then(response => {
            if (!response.error) {
                  Vue.prototype.$globalBrand = response.brand;
                  let defaultLang = "en";
                  if (response.brand == "st-hubert") {
                        defaultLang = "fr";
                  }


                  let brand = (''+response.brand).toLowerCase();

                  // remap burgers-priest to Harveys
                  if (brand.indexOf('bur') >= 0) brand = 'harveys';
                  // remap olive garden to ESM
                  if (brand.indexOf('oliv') >= 0) brand = 'esm';

                  i18n.locale = brand + "-" + defaultLang;
            }

            new Vue({
                  router,
                  i18n,
                  render: h => h(App)
            }).$mount("#app");
      })
      .catch(error => {
      });
